import {
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

export const defaultStyling = {
  checkboxColor: 'rgb(0, 0, 0)',
  fontFamily: 'Roboto',
  fontSize: '14px',
  // fontWeight: '400',
  color: 'rgb(0, 0, 0)',
  backgroundColor: 'rgb(255, 255, 255)',
  align: 'left',
  borderRadius: '0px',
  borderWidth: '2px',
  borderColor: '#000000',
}

export default {
  id: '52423523',
  type: 'checkbox',
  category: 'form',
  // active: false, ?
  content: {
    text: 'Option 1',
  },
  settings: {
    ...defaultSettings,
    // maxLetters
    // maxLength: '50',
    // input type email/text/number/date
    // type: 'email',
    required: false,
    label: 'Checkbox Field',
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}
